import {z} from 'zod';

export const PasswordSchema = z
  .string()
  .min(8, {message: 'Invalid password'})
  .refine((password) => /[a-z]/.test(password), {
    message: 'Password must contain at least one lowercase letter',
  })
  .refine((password) => /[A-Z]/.test(password), {
    message: 'Password must contain at least one uppercase letter',
  })
  .refine((password) => /\d/.test(password), {
    message: 'Password must contain at least one number',
  });

export type Password = z.infer<typeof PasswordSchema>;
